var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 75,
    viewBox: "0 0 177 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 74.1544V21.1855H11.014C15.3861 21.1855 19.1593 21.3265 22.7813 24.0643C26.5513 26.8741 28.5893 31.582 28.5893 36.0081C28.5893 40.716 26.7027 44.2994 22.4819 46.9653C27.1566 49.0734 29.494 54.6929 29.494 59.2599C29.494 69.7283 21.1973 74.1544 10.9399 74.1544H0ZM11.2393 29.9657V42.8931C15.4633 42.8931 17.952 40.2242 17.952 36.218C17.952 32.2117 15.5374 29.7528 11.2393 29.9657ZM11.2393 51.0405V65.3712C15.7627 65.5812 18.406 62.4925 18.406 58.0634C18.406 53.9192 15.6887 50.8966 11.2393 51.0375V51.0405Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4722 21.1855V55.4696C45.4722 59.4758 44.9474 65.5152 51.0548 65.5152C56.5634 65.5152 56.5634 61.6529 56.6375 57.7156V21.1855H67.8768V59.8237C67.8768 65.4432 67.1975 75 50.9808 75C40.498 75 34.2361 70.433 34.2361 60.5254V21.1855H45.4722Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.571 74.1543V21.1854H111.093C113.053 21.1854 136.588 18.5166 136.588 48.0927C136.588 63.1971 130.326 74.1573 112.599 74.1573H102.567L102.571 74.1543ZM125.349 48.0207C125.349 41.2766 123.085 30.5953 113.81 30.5953V64.7384C122.86 65.1612 125.349 54.6208 125.349 48.0177V48.0207Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.384 21.1855V64.3217H165.148V74.1574H142.145V21.1855H153.384Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7784 21.293V50.965L78.8843 21.293H91.7784Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8843 42.0947V74.4326L92.4545 74.1537L78.8843 42.0947Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.145 0.757812H142.196V10.9354H165.145V32.31H176.072V10.9354V0.757812H165.145Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.937b700cd6d59b70e4232a0faeb8be4b.svg";
export { ForwardRef as ReactComponent };